export default __webpack_public_path__ + "static/media/cover_peppermagic.59615d56.mp4";